import React, { useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Mapboxpage from '../Mapboxpage';
import cab from "../images/icons8-cab-stand-100.png";
import maps from "../images/icons8-map-pinpoint-96.png";
import cash from "../images/icons8-wallet-100.png";
import { db } from '../../firebase-config';
import { collection, getDocs, query, where } from 'firebase/firestore';
import airportimg from "../images/airport_transfer_new2.jpg";
import CircularProgress from "@mui/material/CircularProgress";

const Citytocitytransfer = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const [citytocitytransfersservices, citytocitytransfersServices] = useState([]);
  // console.log("citytocitytransfersservicesdata,",citytocitytransfersservices)
  const headerData = citytocitytransfersservices[0];
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);

        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "citytocitytransfers")
        );

        const querySnapshot = await getDocs(q);

        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        citytocitytransfersServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // ✅ important
      }
    };

    fetchServices();
  }, []);

    if (loading) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
        </div>
      );
    }

  return (
    <>

 <div
        className="mainhero-container"
        style={{
          backgroundImage: `url(${headerData?.headerimage || airportimg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="mainhero-content">
          {/* <h1>
   <span style={{ color: "#45B2F7" }}>Luxury</span> Airport Transfers Service
 </h1> */}
          <h1>
            <span style={{ color: "#45B2F7" }}>
              {headerData?.headerTitle?.split(" ")[0] || "Luxury"}
            </span>{" "}
            {headerData?.headerTitle?.split(" ").slice(1).join(" ") || "Luxury Intercity Travel Service"}
          </h1>
          <p>
            {headerData?.headerDescription || "Travel and move between the cities of the Kingdom while enjoying a luxurious experience."}
          </p>
        </div>
        <Mapboxpage />
      </div>

      <br />

     {/* INFO CARDS */}
<div className="cards-containerairport">

  <div className="info-card">
    <div className="card-text">
      <img src={cab} alt="service" className="card-logo" />
      <br />
      <h3>Flexible Hourly Chauffeur Service</h3>
      <p>
        MAS Mobility Services provides reliable hire-by-hour transportation
        solutions designed for maximum flexibility and convenience. Whether
        you need a vehicle for business meetings, shopping trips, city tours,
        personal errands, or multiple destinations, our professional drivers
        ensure smooth and comfortable travel throughout your booking duration.
      </p>
    </div>
  </div>

  <div className="info-card">
    <div className="card-text">
      <img src={maps} alt="service" className="card-logo" />
      <br />
      <h3>Travel on Your Own Schedule</h3>
      <p>
        Enjoy complete freedom with MAS Mobility Services’ hourly hire
        transportation service. Our flexible booking options allow you to
        travel according to your schedule without the stress of arranging
        multiple rides. From corporate travel to family outings, we provide
        dependable door-to-door transportation tailored to your needs.
      </p>
    </div>
  </div>

  <div className="info-card">
    <div className="card-text">
      <img src={cash} alt="service" className="card-logo" />
      <br />
      <h3>Affordable & Transparent Hourly Rates</h3>
      <p>
        MAS Mobility Services offers transparent and competitive hourly
        pricing with no hidden charges. Our hire-by-hour service combines
        comfort, professionalism, and affordability to deliver a premium
        travel experience, ensuring you enjoy safe, convenient, and
        stress-free transportation for every occasion.
      </p>
    </div>
  </div>
</div>
      <br />
      <div>
        {loading ? (
          <div className="skeleton-card">loading ....</div>
        ) : citytocitytransfersservices?.length === 0 ? (
          <h2 style={{ textAlign: "center" }}>No data found</h2>
        ) : (
          citytocitytransfersservices?.map((service, index) => (
            <div
              key={service.id}
              className={`service-section ${index % 2 !== 0 ? "reverse" : ""
                }`}
            >
              {/* IMAGE */}
              <div
                className="service-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <img src={service.image} alt={service.description} />
              </div>

              {/* CONTENT */}
              <div className="service-content">
                <h2>{service.description}</h2>

                <ul className="service-list">
                  {service?.content
                    ?.split(".")
                    .filter((item) => item.trim() !== "")
                    .map((item, index) => (
                      <li key={index}>
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  )
}

export default Citytocitytransfer
